<div>
  <div class="container" style="border: 2px solid black">

    <!-- HEADER -->
    <div class="row">
      <div class="col-2">
        <img style="margin-top: 30%" width="80%" src="../../../assets/img/brand/red.png" />
      </div>
      <div class="col-8" style="padding-top: 30px; text-align: center; padding-bottom: 10px">
        <span style="font-size: 35px; font-weight: bold">हिंदुस्थान प्रकाशन संस्था</span>
        <span style="font-size: 12px; margin-left: 05px">(Reg.No.-BOM-3/1961(GBBSD)</span>
        <hr />
        <div class="row" style="text-align: left">
          <div class="col-6" style="padding-top: 10px">
            <span style="font-size: 14px">
              <span style="font-weight: bold; font-size: 16px">प्रशासकीय कार्यालय :</span>
              116, 117, 118, 119, पहिला मजला, शिल्पीन सेंटर,
              ग. द. आंबेकर मार्ग, वडाळा , मुंबई - 400031.
            </span><br />
            <span style="font-size: 14px">
              <span style="font-weight: bold; font-size: 14px">दूरध्वनी:</span>
              27810235, 27810236
            </span>
          </div>
          <div class="col-6" style="border-left: 2px solid; padding-top: 10px;">
            <span style="font-size: 12px">
              <span style="font-weight: bold; font-size: 14px">मुख्य कार्यालय :</span>
              5/12, कामत औद्योगिक वसाहत, 396 स्वा. वीर सावरकर मार्ग, प्रभादेवी, मुंबई 4000 25.<br />
            </span>
            <span style="font-size: 12px">
              <span style="font-weight: bold; font-size: 14px">दूरध्वनी :</span>
              24221440
            </span>
          </div>
        </div>
      </div>
      <div class="col-2" style="border-left: 2px solid; padding-top: 80px; text-align: center;">
        <span style="font-size: 20px; font-weight: bold">क्रेडिट नोट</span>
      </div>
    </div>

    <!-- CUSTOMER DETAILS -->
    <div class="row" style="border-top: 2px solid; text-align: center;">
      <div class="col-6" style="padding-top: 20px; text-align: left">
        <span style="font-weight: bold; font-size: 14px">Book Seller Name:&nbsp;</span>
        <span style="font-size: 13px">{{ crdtNoteData.bsname }}</span><br />
        <span style="font-weight: bold; font-size: 14px">Address :&nbsp;</span>
        <span style="font-size: 13px">{{ crdtNoteData.receiver_address }}</span>
      </div>
      <div class="col-6" style="border-left: 2px solid;">
        <div class="row" style="border-bottom: 2px solid; padding: 20px 0 10px 0;">
          <div class="col-6" style="text-align: left">
            <span style="font-weight: bold; font-size: 14px">क्रेडिट नोट क्रं.: </span>
            <span>{{ crdtNoteData.crdtnoteno }}</span>
          </div>
          <div class="col-6" style="text-align: left">
            <span style="font-weight: bold; font-size: 14px">दिनांक:&nbsp;</span>
            <span>{{ crdtNoteData.date | date: 'dd-MM-yyyy' }}</span>
          </div>
        </div>
        <div class="row" style="padding-top: 20px">
          <div class="col-12" style="text-align: left">
            <span style="font-weight: bold; font-size: 14px">क्रेडिट नोट रक्कम रू-&nbsp;</span>
            <span style="font-size: 14px">{{ crdtnotetotal }} /-</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="text-align: right">
            <span style="font-weight: bold; font-size: 14px">काढण्यात आली.</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="text-align: left; padding-top: 5px; padding-bottom: 10px">
            <span style="font-weight: bold; font-size: 14px">अक्षरी रक्कम.&nbsp;</span>
            <span style="font-size: 14px">{{ crdtnotetotalwords }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLE HEADER -->
    <div class="row" style="border-top: 2px solid; text-align: center;">
      <div class="col-2 tableDescheader">बिल नंबर</div>
      <div class="col-2 tableDescheader">रक्कम</div>
      <div class="col-2 tableDescheader">राहिलेले बाकी</div>
      <div class="col-2 tableDescheader">क्रेडिट नोट रक्कम</div>
      <div class="col-2 tableDescheader">येणेबाकी</div>
      <div class="col-2 tableDescheader">Remark</div>
    </div>

    <!-- ✅ TABLE BODY — remark bound per book -->
    <div class="row" *ngFor="let item of selectedBooks">
      <div class="col-2 tableDesc">{{ item.invoice_no }}</div>
      <div class="col-2 tableDesc">{{ item.invoice_total }}</div>
      <div class="col-2 tableDesc">{{ item.total_remaining_amt }}</div>
      <div class="col-2 tableDesc">{{ item.credit_amount }}</div>
      <div class="col-2 tableDesc">{{ item.remaining_amt }}</div>
      <!-- ✅ Each book shows its own remark -->
      <div class="col-2 tableDesc">{{ item.remarks
 }}</div>
    </div>

    <!-- TOTALS -->
    <div class="row" style="border-top: 2px solid; font-weight: bold;">
      <div class="col-2 tableDesc">Total -</div>
      <div class="col-2 tableDesc">{{ totalamount }}</div>
      <div class="col-2 tableDesc">{{ totalremainingamt }}</div>
      <div class="col-2 tableDesc">{{ crdtnoteamttotal }}</div>
      <div class="col-2 tableDesc">{{ remainingTotal }}</div>
      <div class="col-2 tableDesc"></div>
    </div>

    <!-- FOOTER -->
    <div class="row" style="margin-top: 3%; padding-bottom: 1%">
      <div class="col-12" style="text-align: right; font-weight: bold; font-size: 14px">
        <span>व्यवस्थापक / लेखापाल</span>
      </div>
    </div>

  </div>

  <!-- ACTION BUTTONS -->
  <button
    class="noPrint"
    style="margin-top: 2%"
    (click)="save()"
    mat-raised-button
    color="primary"
  >
    Save
  </button>
  <button
    class="noPrint"
    style="margin-top: 2%; margin-left: 10px"
    (click)="print()"
    mat-raised-button
    color="primary"
  >
    Print
  </button>
  <button
    class="noPrint"
    style="margin-top: 2%; margin-left: 10px"
    mat-button
    mat-dialog-close
  >
    Close
  </button>

</div>